<template>
  <li :class="ext" v-if="link">
    <a :href="link" target="_blank">
      {{ title }}
    </a>
  </li>
</template>

<script>
export default {
  name: 'File',
  props: ['link', 'ext', 'title']
}
</script>

<style scoped>

</style>
